import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 3v9","key":"svg-1"}],["path",{"d":"M12 12l7 5","key":"svg-2"}],["path",{"d":"M12 12l-7 5","key":"svg-3"}]]

const IconBrandMercedes = createReactComponent('outline', 'brand-mercedes', 'BrandMercedes', __iconNode);

export default IconBrandMercedes;